import axios from "../../../services/axios-config.js";

export async function getAvailableCompanies({ search }) {
  const res = await axios.get("/commissioned/companies/available", { params: { search } });
  return res?.data || [];
}
